// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"0526528b","346":"c23cc042","390":"f85dc254","443":"fe2ee235","580":"fff2b7e5","846":"f5ebe72b"}[chunkId] + ".chunk.css";
};